var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_731_3111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#0C8CE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31L30.41 26.59C30.5961 26.4028 30.8173 26.2543 31.061 26.1531C31.3047 26.0518 31.5661 25.9998 31.83 26H40.17C40.4339 25.9998 40.6953 26.0518 40.939 26.1531C41.1827 26.2543 41.4039 26.4028 41.59 26.59L46 31",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 36V44C28 44.5304 28.2107 45.0391 28.5858 45.4142C28.9609 45.7893 29.4696 46 30 46H42C42.5304 46 43.0391 45.7893 43.4142 45.4142C43.7893 45.0391 44 44.5304 44 44V36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 46V42C39 41.4696 38.7893 40.9609 38.4142 40.5858C38.0391 40.2107 37.5304 40 37 40H35C34.4696 40 33.9609 40.2107 33.5858 40.5858C33.2107 40.9609 33 41.4696 33 42V46",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31H46",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 31V34C46 34.5304 45.7893 35.0391 45.4142 35.4142C45.0391 35.7893 44.5304 36 44 36C43.4157 35.9678 42.8577 35.7467 42.41 35.37C42.2907 35.2838 42.1472 35.2374 42 35.2374C41.8528 35.2374 41.7093 35.2838 41.59 35.37C41.1423 35.7467 40.5843 35.9678 40 36C39.4157 35.9678 38.8577 35.7467 38.41 35.37C38.2907 35.2838 38.1472 35.2374 38 35.2374C37.8528 35.2374 37.7093 35.2838 37.59 35.37C37.1423 35.7467 36.5843 35.9678 36 36C35.4157 35.9678 34.8577 35.7467 34.41 35.37C34.2907 35.2838 34.1472 35.2374 34 35.2374C33.8528 35.2374 33.7093 35.2838 33.59 35.37C33.1423 35.7467 32.5843 35.9678 32 36C31.4157 35.9678 30.8577 35.7467 30.41 35.37C30.2907 35.2838 30.1472 35.2374 30 35.2374C29.8528 35.2374 29.7093 35.2838 29.59 35.37C29.1423 35.7467 28.5843 35.9678 28 36C27.4696 36 26.9609 35.7893 26.5858 35.4142C26.2107 35.0391 26 34.5304 26 34V31",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_731_3111",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_731_3111"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.54902 0 0 0 0 0.913725 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_731_3111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_731_3111",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.70b46cd9e850f5165364e4934f94a66d.svg";
export { ForwardRef as ReactComponent };